import globalThis from 'globalthis';
export var global = globalThis();
